var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTicketReddot(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 15,
    viewBox: "0 0 20 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 12,
    width: 8,
    height: 8,
    rx: 4,
    fill: "#F6475F"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.6583 10.3417C16.3654 10.272 16.0911 10.1545 15.844 9.99801C15.8958 9.99933 15.9478 10 16 10C16.6671 10 17.3088 9.89113 17.9082 9.69019C17.9138 9.72326 17.9167 9.75717 17.9167 9.79167C17.9167 13.4667 16.8 14.5833 13.125 14.5833H7.29175H4.79167C1.11667 14.5833 0 13.4667 0 9.79167V9.375C0 9.03333 0.283333 8.75 0.625 8.75C1.425 8.75 2.08333 8.09167 2.08333 7.29167C2.08333 6.49167 1.425 5.83333 0.625 5.83333C0.283333 5.83333 0 5.55 0 5.20833V4.79167C0 1.11667 1.11667 0 4.79167 0H7.29175H11.5278C11.1905 0.376845 10.9001 0.796574 10.6659 1.25H7.91675V2.70833C7.91675 3.05 7.63341 3.33333 7.29175 3.33333C6.95008 3.33333 6.66675 3.05 6.66675 2.70833V1.25H4.79167C1.85833 1.25 1.26667 1.79167 1.25 4.65833C2.44167 4.94167 3.33333 6.01667 3.33333 7.29167C3.33333 8.56667 2.44167 9.64167 1.25 9.925C1.26667 12.7917 1.85833 13.3333 4.79167 13.3333H6.66675V11.875C6.66675 11.5333 6.95008 11.25 7.29175 11.25C7.63341 11.25 7.91675 11.5333 7.91675 11.875V13.3333H13.125C15.9083 13.3333 16.5833 12.8417 16.6583 10.3417ZM6.66675 8.8167C6.66675 9.15836 6.95008 9.4417 7.29175 9.4417C7.63341 9.4417 7.91675 9.16669 7.91675 8.8167V5.75836C7.91675 5.4167 7.63341 5.13336 7.29175 5.13336C6.95008 5.13336 6.66675 5.4167 6.66675 5.75836V8.8167Z",
    fill: "#222222"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTicketReddot);
export default __webpack_public_path__ + "static/media/ticket-reddot.81f7f0cf7be61bb30aeab3fc64396e1b.svg";
export { ForwardRef as ReactComponent };